import { THead } from "../../../../../../features/auth/auth-state"

interface Props {
    thead: THead[]
}

export default function TheadCoverage({ thead }: Props) {
    return (
        <thead>
            <tr className="bg-gray-50 text-gray-700">
                {thead.map((head) => (
                    <th key={head.id} className={`${head.id === 1 ? "w-[30%]" : head.id === 2 ? "w-[50%]" : "w-[20%]"} border-b border-gray-200 px-2 py-2.5 text-left text-[11px] font-semibold leading-4 break-words sm:px-3 sm:text-xs`}>
                        {head.name}
                    </th>
                ))}
            </tr>
        </thead>
    )
}